import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityNanterrePage() {
  const data = citiesData.find((c) => c.slug === "nanterre")!;
  return <CityPage data={data} />;
}
